module.exports = __webpack_public_path__ + "static/media/5.4aaa7859.JPG";